const accountUrl = window.location.href;
if(accountUrl.includes("account") || accountUrl.includes("addresses")){
function eventListners() {
  // Update sidenav active state based on URL
  const sideNavLinks = document.querySelectorAll(".account-links-selected.account-nav > *");
  const sideNavLinksDesktop = document.querySelectorAll(".account-links-list.account-nav > *");
  const accountPages = document.querySelectorAll(".account-pages");
  const headerHeight = document.querySelector(".section--header").clientHeight;
  const footerHeight = document.querySelector(".section--footer").clientHeight;
  const currentUrl = window.location.pathname + window.location.search;
  var counter = 0;
  var counter1 = 0;
  var counter2 = 0;
  document.querySelector("#MainContent").style.minHeight =
    eval(window.innerHeight - headerHeight - footerHeight) + "px";
  if (currentUrl.includes("/account/orders/")) {
    document
      .querySelector('.account-links-selected [data-href="/account?orders"]')
      .classList.add("active");
    document
      .querySelector(
        '.account-links-list.account-nav [data-href="/account?orders"]'
      )
      .classList.add("active");
  }

  sideNavLinksDesktop.forEach((link, index) => {
    var link_url = link.getAttribute("data-href");
    if (currentUrl == link_url || currentUrl.includes("/account?analytics") && counter == 0) {
      link.classList.add("active");
      counter = 1
    }
  });

  accountPages.forEach((link) => {
    var link_url = link.getAttribute("data-href");
    if (currentUrl == link_url || currentUrl.includes("/account?analytics") && counter1 == 0) {
      link.classList.add("active");
      counter1 = 1;
    }
  });
  sideNavLinks.forEach((link, index) => {
    var link_url = link.getAttribute("data-href");
    if (currentUrl == link_url || currentUrl.includes("/account?analytics") && counter2 == 0) {
      link.classList.add("active");
      counter2 = 1
    }
  });
  document
    .querySelectorAll(".account-links-selected > span")
    .forEach((item) => {
      item.addEventListener("click", (event) => {
        //handle click
        document.querySelector(".account-links-list").classList.add("active");
      });
    });
  document
    .querySelector(".svg-container")
    .addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      document.querySelector(".account-links-list").classList.remove("active");
    });
  var editAddress = document.querySelectorAll(".address-actions .edit");
  editAddress?.forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      item.closest(".address-grid-item").querySelector(".edit-address").classList.add("active");
      document.querySelector("body").classList.add("overflow-hidden");
      document.querySelector(".account-links-list").classList.remove("active");
    });
  });
  document.querySelectorAll(".remove").forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      item
        .closest(".address-grid-item")
        .querySelector("form.address-delete-form")
        .submit();
    });
  });
  document.querySelectorAll(".add-shipping-address").forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      document.querySelector(".add-address").classList.add("active");
      document.querySelector("body").classList.add("overflow-hidden");
      document.querySelector(".account-links-list").classList.remove("active");
    });
  });
  document.querySelectorAll(".close-address-drawer").forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      item.closest(".address-container").classList.remove("active");
      document.querySelector("body").classList.remove("overflow-hidden");
    });
  });
  if (window.innerWidth < 768) {
    let headerHeight = document.querySelector(".header-wrapper").offsetHeight;
    let accountNavHeight = document.querySelector(
      ".account-dashboard-top"
    ).offsetHeight;

    document.querySelectorAll(".address-container").forEach((item) => {
      item.style.top = headerHeight + accountNavHeight + "px";
    });
  }
  
  window.addEventListener("resize", function(event) {
    let top = "0px"
    if (document.body.clientWidth < 768) {
      let headerHeight = document.querySelector(".header-wrapper").offsetHeight;
      let accountNavHeight = document.querySelector(
        ".account-dashboard-top"
      ).offsetHeight;
  
      top = headerHeight + accountNavHeight + "px";
    }

    document.querySelectorAll(".address-container").forEach((item) => {
      item.style.top = top;
    });
  })

  const anchorChildren = document.querySelectorAll(".account-links-list a > span");

  anchorChildren.forEach(function (child) {
    child.addEventListener("click", function (event) {
      event.stopPropagation(); // stop the click event from bubbling up to the parent anchor
    });
  });
    // hide sortBy if clicked outside 
  // Get the element you want to keep visible
  // function checkElementToKeepVisible() {
    const elementLinkToKeepVisible = document.querySelector(".account-links-selected");
    // const addAddres = document.querySelector(".add-shipping-address");
    // Add a click event listener to the document object
    document.addEventListener('click', function(event) {
      
      const elementToKeepVisible = event.target.closest('.address-container-inner');
      
      if(event.target.getAttribute("edit-shipping-address") != null || 
        event.target.getAttribute("add-shipping-address") != null) {
        return
      }
      if (elementToKeepVisible == null || !elementToKeepVisible?.contains(event.target)) {
        // Hide the element if it is not the element you want to keep visible
        document.querySelector(".main-address")?.
        querySelectorAll(".address-container.active").
        forEach((item, index) => {
            item.classList.remove("active");

            document.querySelector("body").
            classList.
            remove("overflow-hidden");
        })
      }
      if (event.target !== elementLinkToKeepVisible 
        && !elementLinkToKeepVisible?.contains(event.target) 
        ) {
            document.querySelector(".account-links-list.account-nav").classList.remove("active")
          } 
    });
  // }
}
document.addEventListener("DOMContentLoaded", function () {
  // do something here ...
  eventListners();
});

const resetPasswordElement = document.getElementById("personal-reset_password");
if(resetPasswordElement != null){

  resetPasswordElement.addEventListener('click', function(){
    const resetForm = document.querySelector('.reset_password_wrapper');
    resetForm.classList.remove('hide');

    const personalDetails = document.querySelector('.personal-detail__wrapper');
    personalDetails.classList.add('hide');

    const welcomeDetails = document.querySelector('.welcome-detail__wrapper');
    resetForm.classList.remove('show');
    welcomeDetails.classList.add('hide');
    
  });
}
}

// Welcome Account Section
const registerLink = 'register';
const loginLink = 'login';

if(accountUrl.includes(registerLink)){
  sessionStorage.setItem('showWelcome', true);
}

if(accountUrl.includes(loginLink)){
  sessionStorage.removeItem('showWelcome');
}
const showWelcome = sessionStorage.getItem('showWelcome');
if(showWelcome) {
  const welcomeDetails = document.querySelector('.welcome-detail__wrapper');
  welcomeDetails.classList.remove('hide');
  welcomeDetails.classList.add('show');  

  sessionStorage.removeItem('showWelcome');
}